// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
// Define a service using a base URL and expected endpoints
const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL_admin}/upload`,
  prepareHeaders: (headers) => {
    const token = getStorage('token');

    // If we have a token set in state, let's assume that we should be passing it.
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const evidencePayApi = createApi({
  reducerPath: 'evidencePayApi',
  baseQuery,
  endpoints: (builder) => ({
    pending: builder.query({
      query: (q) => `/?sorgcode=${q.sorgcode}&status=${q.status}&page=${q.page}&size=${q.size}&search=${q.search}&sortBy=${q.sortBy || 'createdAt'}&sortOrder=${q.sortOrder || 'desc'}`,
    }),
    pendingDetail: builder.query({
      query: (q) => `/detail?transactionId=${q.transactionId}`,
    }),

    approved: builder.query({
      query: (q) => `/?sorgcode=${q.sorgcode}&status=${q.status}&page=${q.page}&size=${q.size}&search=${q.search}&sortBy=${q.sortBy || 'createdAt'}&sortOrder=${q.sortOrder || 'desc'}`,
    }),

    rejected: builder.query({
      query: (q) => `/?sorgcode=${q.sorgcode}&status=${q.status}&page=${q.page}&size=${q.size}&search=${q.search}&sortBy=${q.sortBy || 'createdAt'}&sortOrder=${q.sortOrder || 'desc'}`,
    }),

    approvedButton: builder.mutation({
      query: (req) => {
        const { body } = req;
        return {
          url: '/',
          method: 'POST',
          body,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        };
      },
    }),

    rejectedButton: builder.mutation({
      query: (req) => {
        const {
          body,
        } = req;
        return {
          url: '/',
          method: 'POST',
          body,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        };
      },
    }),

  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
// eslint-disable-next-line max-len
export const {
  usePendingQuery, usePendingDetailQuery, useApprovedQuery, useApprovedButtonMutation, useRejectedButtonMutation, useRejectedQuery,
} = evidencePayApi;
